<div class="d-flex align-items-center" *ngIf="settlements?.length">
    <div class="text-primary">
        {{settlements[0]}}
    </div>
    <div *ngIf="settlements.length > 1" class="settlement-count" [matMenuTriggerFor]="settlementMenu">
        {{settlements.length}}
    </div>
</div>

<mat-menu #settlementMenu="matMenu" class="mat-menu-primary">
    <div *ngFor="let item of settlements; let i= index">
        <span class="text-primary" mat-menu-item *ngIf="i != 0">{{item}}</span>
    </div>   
  </mat-menu> 
